<mat-card>
  <!-- Headers -->
  <app-card-header
    icono="download"
    [title]="title"
    [subtitle]="data.nombreCamara"
  ></app-card-header>

  <!-- Info Banner -->
  <app-info-banner
    icon="info"
    title="Descarga de Video"
    message="Seleccioná la fecha de inicio y la duración del video (máximo 15 minutos). La descarga se procesará en segundo plano."
    margin="0 16px 16px 16px"
  ></app-info-banner>

  @if (form) {
    <form
      id="form"
      [formGroup]="form"
      autocomplete="off"
      (ngSubmit)="onSubmit()"
    >
      <!-- Form -->
      <mat-card-content
        style="margin: 1em 0; overflow: auto"
        class="cardContentDialog"
      >
        <!-- Configuración de descarga -->
        <div class="form-section">
          <app-section-title
            icon="settings"
            title="Configuración de Descarga"
          ></app-section-title>

          <div
            style="
              display: grid;
              grid-template-columns: 1fr 2fr 1fr;
              gap: 16px;
              margin-top: 16px;
            "
          >
            <!-- Canal -->
            <mat-form-field>
              <mat-label>Canal</mat-label>
              <input
                matInput
                type="number"
                formControlName="canal"
                placeholder="0"
                min="0"
              />
              @if (form?.get('canal')?.hasError('required')) {
                <mat-error>Requerido</mat-error>
              }
              @if (form?.get('canal')?.hasError('pattern')) {
                <mat-error>Número válido</mat-error>
              }
            </mat-form-field>

            <!-- Fecha y hora de inicio -->
            <mat-form-field>
              <mat-label>Fecha y hora de inicio</mat-label>
              <input
                matInput
                type="datetime-local"
                formControlName="fechaInicio"
                [max]="maxDateString"
              />
              @if (form?.get('fechaInicio')?.hasError('required')) {
                <mat-error>La fecha es requerida</mat-error>
              }
              <mat-hint>Inicio del video</mat-hint>
            </mat-form-field>

            <!-- Minutos -->
            <mat-form-field>
              <mat-label>Duración (min)</mat-label>
              <input
                matInput
                type="number"
                formControlName="minutos"
                placeholder="5"
                min="1"
                max="15"
              />
              @if (form?.get('minutos')?.hasError('required')) {
                <mat-error>Requerido</mat-error>
              }
              @if (form?.get('minutos')?.hasError('min')) {
                <mat-error>Mínimo 1 min</mat-error>
              }
              @if (form?.get('minutos')?.hasError('max')) {
                <mat-error>Máximo 15 min</mat-error>
              }
              <mat-hint>Máx. 15 min</mat-hint>
            </mat-form-field>
          </div>
        </div>
      </mat-card-content>
      <br />
      <mat-divider></mat-divider>

      <!-- Botones -->
      <mat-card-actions class="actions-create">
        <app-button
          matType="mat-fab extended"
          color="neutral"
          (click)="volver()"
          text="Cerrar"
          icon="close"
        ></app-button>
        <app-button
          matType="mat-fab extended"
          [disabled]="loading || form?.invalid"
          color="primary"
          text="Generar descarga"
          icon="download"
          type="submit"
        ></app-button>
      </mat-card-actions>
    </form>
  }
</mat-card>
